import React, { useState } from "react";
import "./ContactUs.css";
import HeroSection from "../../components/HeroSection/HeroSection";
import ContactImage from "../../assets/images/groupImage4.jpg";
import contactUsgirlImage from "../../assets/images/contactus-girlImage.jpg";
import Footer from "../../components/Footer";
import mapChauwk from "../../assets/images/mapChauwk.png";
import QRCodeCube from "../../assets/images/qr-cube.jpeg";
import ReviewSlider from "../../components/ReviewSlider/ReviewSlider";

import GoogleQR from "../../assets/images/google-qr-cahuwk.jpeg";

import { ENDPOINTS } from "../../endpoint";
import { toast } from "react-hot-toast";
import { PopupButton, useCalendlyEventListener } from "react-calendly";
import { FaWhatsapp } from "react-icons/fa";

const ContactUs = () => {
  useCalendlyEventListener({
    onEventScheduled: (e) => {
      toast.success("Demo Scheduled Successfully!");
    },
  });

  const [activeFaq, setActiveFaq] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    location: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(
        ENDPOINTS.SEND_EMAIL,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            full_name: formData.name,
            phone: formData.phone,
            email: formData.email,
            location: formData.location,
            subject: formData.subject,
            message: formData.message,
            contribution: `Phone: ${formData.phone}\nLocation: ${formData.location}\nSubject: ${formData.subject}\n\nMessage:\n${formData.message}`,
          }),
        }
      );

      const ct = res.headers.get("content-type") || "";
      const data = ct.includes("application/json") ? await res.json() : {};

      if (!res.ok) {
        throw new Error(data?.message || "Failed to send. Please try again.");
      }

      toast.success("Thanks! Your message has been sent.");
      setFormData({
        name: "",
        phone: "",
        email: "",
        location: "",
        subject: "",
        message: "",
      });
    } catch (err) {
      toast.error(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container">
      {/* Hero */}
      <div className="hero-section">
        <HeroSection
          cName="hero-section"
          title="Contact Us"
          text="Get in touch with us today"
          heroImg={ContactImage}
          qrImg={QRCodeCube}
        />
      </div>

      {/* Page intro */}
      <section className="contact-us-heading container">
        <h4>CONTACT US</h4>
        <p>
          At Chauwk, we combine technology, communication, and innovation to
          create impactful solutions for enterprises and workforce ecosystems.
          Whether you need support, want to explore our AI-powered services, or
          discuss collaboration opportunities, we would be happy to connect with
          you.
        </p>
      </section>

      {/* Book a Demo Section */}
      <section className="book-demo-section container" style={{ marginTop: "60px", marginBottom: "60px", textAlign: "center" }}>
        <PopupButton
          url="https://calendly.com/vcpl-bdm/30min"
          rootElement={document.getElementById("root")}
          text="Book a Demo"
          className="reviews-section__button"
          style={{ border: "none", cursor: "pointer", display: "inline-block" }}
        />
      </section>

      {/* Two-column content */}
      <section className="contact-content container">
        {/* Left: form */}
        <div className="contact-form-section card">
          <h2>We’d love to hear from you!</h2>
          <p>
            Fill out the form below, and we will get back to you as soon as
            possible.
          </p>

          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="location"
              placeholder="Location"
              value={formData.location}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows="3"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

        {/* Right: contact info + map */}
        <div className="contact-info-section">
          <div className="whatsapp-contact-card">
            <div className="whatsapp-icon-wrapper">
              <FaWhatsapp className="whatsapp-icon" />
            </div>
            <div className="whatsapp-contact-details">
              <h4>Chat on WhatsApp</h4>
              <p>We're here to help you</p>
              <a href="https://wa.me/916301756566" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
                +91 6301756566
              </a>
            </div>
          </div>

          <div className="map-container framed-map">
            <iframe
              title="company location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.257545465922!2d78.37567847516593!3d17.44751908345155!2m3!1f0!2f0!3m0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e887e35b7b%3A0x6b45a05b3c375531!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1715610000000!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              style={{ border: 0, width: "100%", height: "100%" }}
            ></iframe>
          </div>
        </div>
      </section>

      {/* Reviews Combined Section */}
      <section className="contact-reviews container">
        <div className="reviews-main-content">
          {/* Left: QR Card */}
          <div className="google-qr-card-box">
            <div className="google-qr-card large-qr">
              <img src={GoogleQR} alt="Google Review QR" className="google-review-qr" />
            </div>
          </div>

          {/* Right: Text and Actions */}
          <div className="reviews-text-section balanced">
            <div className="reviews-cta-wrapper-inline">
              <a
                href="https://g.page/r/Cfn830j5r0fDEBM/review"
                target="_blank"
                rel="noopener noreferrer"
                className="reviews-cta-link"
              >
                Read our online reviews
              </a>
            </div>
            
            <h2 className="reviews-section__title">What the Internet Says</h2>
            <p className="reviews-section__subtitle">
              Read reviews from the netizens and our clients
            </p>
            
            <a
              href="https://g.page/r/Cfn830j5r0fDEBM/review"
              target="_blank"
              rel="noopener noreferrer"
              className="reviews-section__button"
            >
              Leave Us a Review
            </a>
          </div>
        </div>

        <div className="reviews-carousel">
          <ReviewSlider />
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section container">
        <div className="faq-header">
          <button className="faq-button">FAQ’s</button>
          <div>
            <h2 className="faq-title">
              Frequently Asked <br />
              Questions
            </h2>
            <p className="faq-subtitle">
              Find answers to common queries below to help you navigate our
              services.
            </p>
          </div>
        </div>

        <div className="faq-content">
          {/* LEFT SIDE */}
          <div className="faq-left">
            <div className="still-questions">
              <h2>Still Have Questions?</h2>
              <p>
                Can’t find the answer to your question? Send us an email and
                we’ll get back to you as soon as possible.
              </p>
              <a href="mailto:hello@chauwk.com" className="send-email">
                Send Email
              </a>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="faq-right">
            {[
              {
                question: "What is Chauwk?",
                answer:
                  "Chauwk is a no code platform designed for companies who have frontline workers in their workforce. It offers AI powered solutions for customer and workforce engagement, upskilling, loyalty, and professional growth.",
              },
              {
                question: "How can I register on Chauwk?",
                answer:
                  "You can register by visiting our official website and following the sign-up process, or by contacting our support team for assistance.",
              },
              {
                question: "Is Chauwk free to use?",
                answer:
                  "Chauwk offers both free and premium plans based on the features your organization needs.",
              },
              {
                question: "How do I contact Chauwk support?",
                answer:
                  "You can contact our support team anytime via hello@chauwk.com or by calling 040-489-56302.",
              },
              {
                question: "Can I update my profile information?",
                answer:
                  "Yes! You can easily edit your profile details under the Account Settings section after logging in.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${activeFaq === index ? "active" : ""}`}
              >
                <button
                  className="faq-question"
                  onClick={() =>
                    setActiveFaq(activeFaq === index ? null : index)
                  }
                >
                  {faq.question}
                  <span className="faq-icon">
                    {activeFaq === index ? "▲" : "▼"}
                  </span>
                </button>
                {activeFaq === index && (
                  <div className="faq-answer">
                    <p>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactUs;
